export default __webpack_public_path__ + "static/media/profile.97b5b6a7.png";